import router from './router';
import store from './store';
import APPOINTMENT_MUTATION_TYPES from './store-modules/appointment/appointment.mutation-types';

import {
  isValidChassie,
} from './utils';

// Private functions
function hasNoTires() {
  const {
    tireStock,
  } = store.state.appointment;

  return tireStock.tz === 0 && tireStock.ms === 0 && tireStock.ts === 0;
}

function hasEnoughTires() {
  const {
    tireStock,
  } = store.state.appointment;

  let correctWinterStock = false;
  if (tireStock.ms > 0) {
    correctWinterStock = tireStock.ms % 4 === 0 || tireStock.ms % 6 === 0;
  }

  let correctSummerStock = false;
  if (tireStock.tz > 0) {
    correctSummerStock = tireStock.tz % 4 === 0 || tireStock.tz % 6 === 0;
  }

  let correctSeasonStock = false;
  if (tireStock.ts > 0) {
    correctSeasonStock = tireStock.ts % 4 === 0 || tireStock.ts % 6 === 0;
  }

  return correctWinterStock || correctSummerStock || correctSeasonStock;
}

// Deeplink redirect
const posDepots = [116, 121, 143, 120];

function getDepotForPosRedirect(depotId) {
  // Pos=Point of Sale
  // Cepwa  = Wavre = 116
  // Cepwz  = Wanze= 121
  // Cepg   = Gosselies= 143
  // Cepv   = Verviers= 120
  switch (depotId) {
    case 116:
      return 'cepwa';
    case 121:
      return 'cepwz';
    case 143:
      return 'cepg';
    case 120:
      return 'cepv';
    default:
      return 'cepwa';
  }
}

function getWorkForPosRedirect() {
  // Work=
  // 1 Switch Summer / Winter
  // 2 Switch Winter / Summer
  // 3 New Tyre Summer
  // 4 New Tyre winter
  // 5 Geo

  // tireType: ms == winterband | ts == all season | tz == zomerband
  // serviceType: change, new tires, alignment, maintenance

  const {
    tireType,
    serviceType,
  } = store.state.appointment;

  switch (serviceType) {
    case '':
    case 'change':
      if (tireType === 'ms') {
        return 1;
      }

      return 2;
    case 'new tires':
      if (tireType === 'ms') {
        return 4;
      }

      return 3;
    default:
      return 1;
  }
}

function getTireSizeForPosRedirect(position) {
  const {
    tireSizes,
  } = store.state.appointment;

  const tire = tireSizes[position];

  return `${tire.width}${tire.height}${tire.diameter}${tire.speedIndex}${tire.loadCapacity}`;
}

function getStockForPosRedirect() {
  // FL = Front Left (0=No, 1=Yes)
  // FR = Front Right (0=No, 1=Yes)
  // RL = Rear Left (0=No, 1=Yes)
  // RR = Rear Right (0=No, 1=Yes)

  const {
    tireType,
    tireLocations,
  } = store.state.appointment;

  // State -> 0/1/2/3 -> Disabled/Not active/Active/Stock
  const fl = tireLocations.t1l1[`${tireType}Stock`] === 2 || tireLocations.t1l1[`${tireType}Stock`] === 3 ? 1 : 0;
  const fr = tireLocations.t1r1[`${tireType}Stock`] === 2 || tireLocations.t1r1[`${tireType}Stock`] === 3 ? 1 : 0;
  const rl = tireLocations.t2l1[`${tireType}Stock`] === 2 || tireLocations.t2l1[`${tireType}Stock`] === 3 ? 1 : 0;
  const rr = tireLocations.t2r1[`${tireType}Stock`] === 2 || tireLocations.t2r1[`${tireType}Stock`] === 3 ? 1 : 0;

  return `${fl}/${fr}/${rl}/${rr}`;
}

function redirectToPos() {
  // /Pos/Work/Plate/Driver/Mail/Adress/ZipCode/City/Gsm/Tel/ROF/Front/Rear/FL/FR/RL/RR
  // /cepg/1/1BFC874/Marc%20Smolders/marc.smolders%40softwheels.be/Rue%20de%20Gourmette%2034/7090/Hennuyeres/%2B32494527091/0032550112/1/2055516h91/2055516h91/1/1/0/0

  const {
    depotId,
    licensePlate,
    personalData,
    runFlat,
  } = store.state.appointment;

  const redirectToPosBaseUrl = 'https://agenda.lecomptoirdupneu.be/processLink';

  const pos = getDepotForPosRedirect(depotId);
  const work = getWorkForPosRedirect();

  // -- Peronsal data --
  // Driver/Mail/Adress/ZipCode/City/Gsm/Tel/
  const space = personalData.firstName === '' && personalData.lastName === '' ? '' : '%20';
  const personalDataUrl = `${personalData.firstName}${space}${personalData.lastName}/${personalData.email}/${personalData.address}/${personalData.zipCode}/${personalData.city}/${personalData.cellphoneNumber}/${personalData.cellphoneNumber}`;

  // -- Tireinfo --
  // /ROF/Front/Rear/FL/FR/RL/RR
  // Front= Tyre Dimension for front (Width Height Diameter SI LI) no separator
  // Rear = Tyre Dimension for rear (Width Height Diameter SI LI) no separator
  const frontTire = getTireSizeForPosRedirect('frontTire');
  const backTire = getTireSizeForPosRedirect('backTire');

  const stock = getStockForPosRedirect();

  // ROF= Run Flat (0=No, 1=Yes)
  const isRunFlat = runFlat ? 1 : 0;
  const tireUrl = `${isRunFlat}/${frontTire}/${backTire}/${stock}`;

  const redirectToPosUrl = `${redirectToPosBaseUrl}/${pos}/${work}/${licensePlate}/${personalDataUrl}/${tireUrl}`;
  window.location.assign(redirectToPosUrl);
}

function checkIfRedirectToPos(depotId) {
  if (posDepots.indexOf(depotId) >= 0) {
    redirectToPos();
  }
}

// Public functions
function validateStep1LicensePlate() {
  const {
    vehiculeType,
    appointment,
  } = store.state.appointment;

  if (appointment.depotId !== 0) {
    router.push({
      name: 'hasAppointment',
    });

    return;
  }

  switch (vehiculeType) {
    case 'part':
    case 'customer':
    case 'lease':
    case 'fleet':
      router.push({
        name: 'step3ServiceType',
      });
      break;
    case 'unknown':
      router.push({
        name: 'step2VehiculeType',
      });
      break;
    default:
      router.push({
        name: 'step2VehiculeType',
      });
  }
}

function validateStep1LicensePlateMobile() {
  const {
    vehiculeType,
    appointment,
    company,
    serviceType,
    customerDataRaw,
  } = store.state.appointment;

  if (appointment.addressId !== '') {
    router.push({
      name: 'hasAppointment',
    });

    return;
  }

  switch (vehiculeType) {
    case 'customer':
    case 'lease':
    case 'fleet':
      // router.push({
      //   path: `/mobile/${company}/tire-info`,
      // });

      if (vehiculeType === 'lease' || vehiculeType === 'fleet') {
        // Als ze nieuwe banden kiezen clearen we de huidige stock
        // & we zetten het tiretype op het type banden die momenteel op de wagen ligt
        if (serviceType === 'new-tires') {
          store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.CLEAR_STOCK}`);
          // Type ophalen met stock op false (banden die op wagen liggen)
          const tireTypeOnCar = customerDataRaw.tires.find(t => t.stock === false);
          if (tireTypeOnCar !== undefined) {
            store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_TIRETYPE}`, { tireType: tireTypeOnCar.tireType.toLowerCase(), changeTireType: true });
          }
        }
        if (serviceType === 'change') {
          store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_STOCK}`);
        }

        if (hasEnoughTires()) {
          router.push({
            path: `/mobile/${company}/appointment-info`,
          });
        } else {
          router.push({
            path: `/mobile/${company}/tire-info`,
          });
        }
      }
      break;
    case 'unknown':
      router.push({
        path: `/mobile/${company}/vehicle-type`,
      });
      break;
    case 'part':
      router.push({
        name: '/',
      });
      break;
    default:
      router.push({
        path: `/mobile/${company}/vehicle-type`,
      });
  }
}

// Public functions
function validateStep1LicensePlateMobileRegion() {
  const {
    vehiculeType,
    appointment,
  } = store.state.appointment;
  if (appointment.depotId !== 0) {
    router.push({
      name: 'hasAppointment',
    });

    return;
  }

  switch (vehiculeType) {
    case 'part':
    case 'customer':
    case 'lease':
    case 'fleet':
      router.push({
        name: 'step3ServiceTypeMobileRegion',
      });
      break;
    case 'unknown':
      router.push({
        name: 'step2VehiculeTypeMobileRegion',
      });
      break;
    default:
      router.push({
        name: 'step2VehiculeTypeMobileRegion',
      });
  }
}

function validateStep1Maintenance() {
  router.push({
    name: 'step7Confirmation',
  });
}

function validateStep2VehiculeType() {
  const {
    vehiculeType,
  } = store.state.appointment;

  switch (vehiculeType) {
    case 'lease':
    case 'customer':
    case 'part':
      router.push({
        name: 'step3ServiceType',
      });
      break;
    case 'fleet':
      router.push({
        name: 'contactFleetAgent',
      });
      break;
    default:
      router.push({
        name: 'step3ServiceType',
      });
  }
}

function validateStep2VehiculeTypeMobileRegion() {
  const {
    vehiculeType,
  } = store.state.appointment;

  switch (vehiculeType) {
    case 'lease':
    case 'customer':
    case 'part':
      router.push({
        name: 'step3ServiceTypeMobileRegion',
      });
      break;
    case 'fleet':
      router.push({
        name: 'contactFleetAgent',
      });
      break;
    default:
      router.push({
        name: 'step3ServiceTypeMobileRegion',
      });
  }
}

function validateStep2VehiculeTypeMobile() {
  const {
    vehiculeType,
    customerDataRaw,
    serviceType,
    company,
    chassie,
  } = store.state.appointment;

  if (customerDataRaw.licensePlate === null && vehiculeType === 'fleet') {
    router.push({
      name: 'contactFleetAgent',
    });

    return;
  }

  // Customertype unknown
  if (customerDataRaw.customerType === 'unknown' &&
    (serviceType === 'new-tires' || serviceType === 'change') &&
    (vehiculeType === 'lease' || vehiculeType === 'fleet')) {
    router.push({
      path: `/mobile/${company}/leasing-company`,
    });

    return;
  }

  if (vehiculeType === 'lease') {
    // Als ze nieuwe banden kiezen clearen we de huidige stock
    // & we zetten het tiretype op het type banden die momenteel op de wagen ligt
    if (serviceType === 'new-tires') {
      store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.CLEAR_STOCK}`);
      // Type ophalen met stock op false (banden die op wagen liggen)
      const tireTypeOnCar = customerDataRaw.tires.find(t => t.stock === false);
      if (tireTypeOnCar !== undefined) {
        store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_TIRETYPE}`, { tireType: tireTypeOnCar.tireType.toLowerCase(), changeTireType: true });
      }
    }
    if (serviceType === 'change') {
      store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_STOCK}`);
    }

    if (hasEnoughTires() && isValidChassie(chassie)) {
      router.push({
        path: `/mobile/${company}/appointment-info`,
      });
    } else {
      router.push({
        path: `/mobile/${company}/tire-info`,
      });
    }

    return;
  }

  switch (vehiculeType) {
    case 'lease':
    case 'customer':
    case 'part':
      router.push({
        path: `/mobile/${company}/tire-info`,
      });
      break;
    case 'fleet':
      router.push({
        name: 'contactFleetAgent',
      });
      break;
    default:
      router.push({
        path: `/mobile/${company}/tire-info`,
      });
  }
}

function validateStep3ServiceType() {
  const {
    customerDataRaw,
    serviceType,
    vehiculeType,
    depotId,
  } = store.state.appointment;

  // If serviceType is change and depot is in redirect depotlist, redirect
  if (serviceType === 'change') {
    checkIfRedirectToPos(depotId);
  }

  // Customertype unknown
  if (customerDataRaw.customerType === 'unknown' &&
    (serviceType === 'new-tires' || serviceType === 'change' || serviceType === 'maintenance') &&
    (vehiculeType === 'lease' || vehiculeType === 'fleet')) {
    router.push({
      name: 'step4LeasingCompany',
    });

    return;
  }

  // Uitlijnen en balanceren naar de juiste info pagina sturen
  // Particulier en customer die nieuwe banden willen naar de webshop sturen
  switch (serviceType) {
    case 'alignment':
      router.push({
        name: 'alignmentInfo',
      });

      return;
    case 'maintenance':
      router.push({
        name: 'maintenanceInfo',
      });

      return;
    case 'new-tires':
      if (vehiculeType === 'part' || (vehiculeType === 'customer' && customerDataRaw.customerType === 'unknown')) {
        router.push({
          name: 'goToWebshop',
        });

        return;
      }
      break;
    case 'change':
      if (customerDataRaw.customerType === 'unknown' && vehiculeType === 'customer') {
        router.push({
          name: 'goToWebshop',
        });

        return;
      }
      break;
    default:
      break;
  }

  // Particulier zonder stock naar webshop sturen
  if (vehiculeType === 'part') {
    if (hasNoTires()) {
      router.push({
        name: 'goToWebshop',
      });
    } else {
      if (hasEnoughTires()) {
        router.push({
          name: 'step6AppointmentInfo',
        });
      } else {
        router.push({
          name: 'step5TireInfo',
        });
      }

      return;
    }

    return;
  }

  // Als lease of fleet banden tekort heeft -> TireInfo
  // 4 banden op stock -> Appointment
  if (vehiculeType === 'lease' || vehiculeType === 'fleet') {
    // Als ze nieuwe banden kiezen clearen we de huidige stock
    // & we zetten het tiretype op het type banden die momenteel op de wagen ligt
    if (serviceType === 'new-tires') {
      store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.CLEAR_STOCK}`);
      // Type ophalen met stock op false (banden die op wagen liggen)
      const tireTypeOnCar = customerDataRaw.tires.find(t => t.stock === false);
      if (tireTypeOnCar !== undefined) {
        store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_TIRETYPE}`, { tireType: tireTypeOnCar.tireType.toLowerCase(), changeTireType: true });
      }
    }
    if (serviceType === 'change') {
      store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_STOCK}`);
    }

    if (hasEnoughTires()) {
      router.push({
        name: 'step6AppointmentInfo',
      });
    } else {
      router.push({
        name: 'step5TireInfo',
      });
    }

    return;
  }

  router.push({
    name: 'step5TireInfo',
  });
}

function validateStep3ServiceTypeMobileRegion() {
  const {
    customerDataRaw,
    serviceType,
    vehiculeType,
    depotId,
    chassie,
  } = store.state.appointment;

  // If serviceType is change and depot is in redirect depotlist, redirect
  if (serviceType === 'change') {
    checkIfRedirectToPos(depotId);
  }

  // Customertype unknown
  if (customerDataRaw.customerType === 'unknown' &&
    (serviceType === 'new-tires' || serviceType === 'change' || serviceType === 'maintenance') &&
    (vehiculeType === 'lease' || vehiculeType === 'fleet')) {
    router.push({
      name: 'step4LeasingCompanyMobileRegion',
    });

    return;
  }

  // Uitlijnen en balanceren naar de juiste info pagina sturen
  // Particulier en customer die nieuwe banden willen naar de webshop sturen
  switch (serviceType) {
    case 'alignment':
      router.push({
        name: 'alignmentInfo',
      });

      return;
    case 'maintenance':
      router.push({
        name: 'maintenanceInfo',
      });

      return;
    case 'new-tires':
      if (vehiculeType === 'part' || (vehiculeType === 'customer' && customerDataRaw.customerType === 'unknown')) {
        router.push({
          name: 'goToWebshop',
        });

        return;
      }
      break;
    case 'change':
      if (customerDataRaw.customerType === 'unknown' && vehiculeType === 'customer') {
        router.push({
          name: 'goToWebshop',
        });

        return;
      }
      break;
    default:
      break;
  }

  // Particulier zonder stock naar webshop sturen
  if (vehiculeType === 'part') {
    if (hasNoTires()) {
      router.push({
        name: 'goToWebshop',
      });
    } else {
      if (hasEnoughTires() && isValidChassie(chassie)) {
        router.push({
          name: 'step6AppointmentInfoMobileRegion',
        });
      } else {
        router.push({
          name: 'step5TireInfoMobileRegion',
        });
      }

      return;
    }

    return;
  }

  // Als lease of fleet banden tekort heeft -> TireInfo
  // 4 banden op stock -> Appointment
  if (vehiculeType === 'lease' || vehiculeType === 'fleet') {
    // Als ze nieuwe banden kiezen clearen we de huidige stock
    // & we zetten het tiretype op het type banden die momenteel op de wagen ligt
    if (serviceType === 'new-tires') {
      store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.CLEAR_STOCK}`);
      // Type ophalen met stock op false (banden die op wagen liggen)
      const tireTypeOnCar = customerDataRaw.tires.find(t => t.stock === false);
      if (tireTypeOnCar !== undefined) {
        store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_TIRETYPE}`, { tireType: tireTypeOnCar.tireType.toLowerCase(), changeTireType: true });
      }
    }
    if (serviceType === 'change') {
      store.commit(`appointment/${APPOINTMENT_MUTATION_TYPES.SET_STOCK}`);
    }

    if (hasEnoughTires() && isValidChassie(chassie)) {
      router.push({
        name: 'step6AppointmentInfoMobileRegion',
      });
    } else {
      router.push({
        name: 'step5TireInfoMobileRegion',
      });
    }

    return;
  }

  router.push({
    name: 'step5TireInfoMobileRegion',
  });
}

function validateStep4LeasingCompanyInfo() {
  const {
    serviceType,
  } = store.state.appointment;
  if (serviceType === 'maintenance') {
    router.push({
      name: 'maintenanceInfo',
    });
  } else {
    router.push({
      name: 'step5TireInfo',
    });
  }
}

function validateStep4LeasingCompanyInfoMobileRegion() {
  router.push({
    name: 'step5TireInfoMobileRegion',
  });
}

function validateStep4LeasingCompanyInfoMobile() {
  const {
    company,
  } = store.state.appointment;
  router.push({
    path: `/mobile/${company}/tire-info`,
  });
}

function validateStep5TireInfo() {
  router.push({
    name: 'step6AppointmentInfo',
  });
}

function validateStep5TireInfoMobileRegion() {
  router.push({
    name: 'step6AppointmentInfoMobileRegion',
  });
}


function validateStep5TireInfoMobile() {
  const {
    company,
  } = store.state.appointment;
  router.push({
    path: `/mobile/${company}/appointment-info`,
  });
}

function validateStep5TireInfoMobileTPP() {
  const {
    rid,
  } = store.state.appointment;
  router.push({
    path: `/tpp/${rid}/appointment-info`,
  });
}

function validateStep6AppointmentInfo() {
  router.push({
    name: 'step7Confirmation',
  });
}

export default {
  validateStep1LicensePlate,
  validateStep1Maintenance,
  validateStep2VehiculeType,
  validateStep3ServiceType,
  validateStep4LeasingCompanyInfo,
  validateStep5TireInfo,
  validateStep6AppointmentInfo,
  checkIfRedirectToPos,
  validateStep5TireInfoMobile,
  validateStep1LicensePlateMobile,
  validateStep2VehiculeTypeMobile,
  validateStep4LeasingCompanyInfoMobile,
  validateStep5TireInfoMobileTPP,
  validateStep2VehiculeTypeMobileRegion,
  validateStep1LicensePlateMobileRegion,
  validateStep3ServiceTypeMobileRegion,
  validateStep4LeasingCompanyInfoMobileRegion,
  validateStep5TireInfoMobileRegion,
};
